export const SDK_VERSION = '6.1.2';
